// extracted by mini-css-extract-plugin
module.exports = {"row":"bm_T","column":"bm_dj"};